import React from 'react';
import dayjs from 'dayjs';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PropTypes } from 'prop-types';
// import { TimePicker } from '@mui/x-date-pickers';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

export function CustomDateTimePicker(props) {
    const { value, minDate, handleChange, label = '', dateOnly = false, className = '', timeOnly = false, pickerProps } = props;
    const today = minDate !== undefined ? minDate : dayjs();
    const pickerUI = () => {
        if (timeOnly) {
            return (
                <DemoContainer components={['TimePicker']}>
                    {/* <TimePicker label="Basic time picker" /> */}
                    <TimePicker
                        label={label || 'Time'}
                        value={value}
                        onChange={handleChange}
                        className={className}
                        // minTime={today}
                        {...pickerProps}
                    />
                </DemoContainer>
            );
        }
        if (dateOnly) {
            return (
                <DatePicker
                    label={label || 'Date'}
                    value={value}
                    onChange={handleChange}
                    minDate={today}  // Disable past dates
                    textField={(params) => <TextField {...params} />}
                    className={className}
                />
            );
        }

        return (
            <DemoContainer components={['DateTimePicker']}>
                <DateTimePicker
                    label={label || 'Date & Time'}
                    value={value}
                    onChange={handleChange}
                    minDate={today}  // Disable past dates
                    // renderInput={(params) => <TextField {...params} />}
                    textField={(params) => <TextField {...params} />}
                    className={className}
                />
            </DemoContainer>
        );
    };
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={3}>
                {pickerUI()}
            </Stack>
        </LocalizationProvider>
    );
}

CustomDateTimePicker.propTypes = {
    value: PropTypes.instanceOf(dayjs).isRequired,
    minDate: PropTypes.instanceOf(dayjs) || null,
    handleChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    size: PropTypes.string,
    className: PropTypes.string,
    dateOnly: PropTypes.bool,
    timeOnly: PropTypes.bool,
    pickerProps: PropTypes.object,
};


